import WeatherDashboard from "./assets/images/WeatherDashboard.PNG";
import NoteTaker from "./assets/images/NoteTaker.png";
import SocialJunk from "./assets/images/chat.png";
import BudgetTracker from "./assets/images/BudgetTracker.png";
import TechBlog from "./assets/images/TechBlog.png";
import SocialNetworkApi from "./assets/images/SocialNetworkApi.png";
import MernReact from "./assets/images/plant.png";
import EmployeeTracker from "./assets/images/TRACK1.MOV";
//import EmployeeTracker from "./assets/images/TRACK2.MOV";




export default [
  
   {
    id: 1,
    name: "Social Junk",
    image: SocialJunk,
    github: "https://github.com/mssjhu9/social-junk",
    deploy: "https://chitchat2022.herokuapp.com​",
  },
  {
    id: 2,
    name: "Note Taker",
    image: NoteTaker,
    github: "https://github.com/mssjhu9/note-taker",
    deploy: "https://stormy-wildwood-72332.herokuapp.com/",
  },
  {
    id: 3,
    name: "Budget Tracker",
    image: BudgetTracker,
    github: "https://github.com/mssjhu9/budget-tracker",
    deploy: "https://budgettrack2022.herokuapp.com/",
  },
  {
    id: 4,
    name: "Tech Blog",
    image: TechBlog,
    github: "https://github.com/mssjhu9/tech-blog",
    deploy: "https://evening-anchorage-14800.herokuapp.com/",
  },
  {
    id: 5,
    name: "Employee Tracker",
    image: EmployeeTracker,
    github: "https://github.com/mssjhu9/employee-tracker",
    deploy: EmployeeTracker,
  },
  {
    id: 6,
    name: "Weather Dashboard",
    image: WeatherDashboard,
    github: "https://github.com/mssjhu9/weather-dashboard",
    deploy: "https://mssjhu9.github.io/weather-dashboard/",
  },
  {
    id: 7,
    name: "Social Network Api",
    image: SocialNetworkApi,
    github: "https://github.com/mssjhu9/social-network-api",
    deploy: "https://localhost/3001",
  },
  {
    id: 8,
    name: "Houseplant Heaven",
    image: MernReact,
    github: "https://github.com/mssjhu9/mern-react",
   deploy: "https://houseplant22.herokuapp.com/",
  },
];
